package com.parmartechnologies.core.feature.payment.model

import com.parmartechnologies.core.extension.BaseDataClass
import com.parmartechnologies.core.feature.cart.model.CartItem
import com.parmartechnologies.core.feature.payment.status.PaymentStatus
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class Payment @OptIn(ExperimentalTime::class) constructor(
    @SerialName("payment_id") var paymentId: Long = Clock.System.now().epochSeconds,
    @SerialName("payment_created_at") var paymentCreatedAt: Long = 0,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("selected_business_id") var selectedBusinessID: String = "",
    @SerialName("payment_type") var paymentType: String = "",
    @SerialName("device_id") var deviceId: String = "",
    @SerialName("payment_items") var paymentItems: ArrayList<CartItem> = arrayListOf(),
    @SerialName("currency") var currency: String = "",
    @SerialName("entity") var entity: String = "",
    @SerialName("payment_gateway_order_id") var paymentGatewayOrderID: String = "",
    @SerialName("page_url") var pageUrl: String = "",
    @SerialName("pending_amount") var pendingAmount: Float = 0f,
    @SerialName("cleared_amount") var clearedAmount: Float = 0f,
    @SerialName("instant_discount") var instantDiscount: Double = 0.0,
    @SerialName("offer_id") var offerID: Double = 0.0,
    @SerialName("receipt") var receipt: Double = 0.0,
    @SerialName("coupon") var coupon: Double = 0.0,
    @SerialName("status") var status: PaymentStatus? = null,
): BaseDataClass()